import { render, staticRenderFns } from "./ContentBlockFormWrapper.vue?vue&type=template&id=4bc4f30a&"
import script from "./ContentBlockFormWrapper.vue?vue&type=script&lang=ts&"
export * from "./ContentBlockFormWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ContentBlockFormWrapper.vue?vue&type=style&index=0&id=4bc4f30a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports